<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="auto"
      range
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="formatDate"
          :label="label"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          clearable
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        scrollable
        locale="pt-BR"
        color="primary"
        v-on:change="$emit('onChange', date)"
      >
        <v-spacer></v-spacer>

        <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>
import moment from "moment";
export default {
  components: {},
  props: {
    label: {
      type: String,
      default: "Data",
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      menu: false,
      date: this.value,
    };
  },
  computed: {
    formatDate: {
      get() {
        return this.date ? moment(this.date).format("DD/MM/YYYY") : "";
      },
      set(date) {
        this.date = date;
        this.$emit("onChange", date);
      },
    },
  },
};
</script>
